// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as URL$AppTemplateReasonReact from "../../utilities/URL.bs.js";
import * as Date$AppTemplateReasonReact from "../../utilities/Date.bs.js";

import './StoryItem.css';
;

function StoryItem(Props) {
  var id = Props.id;
  var title = Props.title;
  var url = Props.url;
  var points = Props.points;
  var author = Props.author;
  var createdAt = Props.createdAt;
  var numberOfComments = Props.numberOfComments;
  var storyPath = "/item/" + id;
  var comments = numberOfComments !== 0 ? React.createElement("a", {
          className: "story-item-footer-comments",
          href: storyPath
        }, String(numberOfComments) + " comments") : React.createElement(React.Fragment, undefined);
  return React.createElement("div", {
              className: "story-item"
            }, React.createElement("a", {
                  className: "story-item-header",
                  href: url
                }, React.createElement("span", {
                      className: "story-item-header-title"
                    }, title), React.createElement("small", {
                      className: "story-item-header-domain"
                    }, React.createElement("span", undefined, "("), React.createElement("span", undefined, URL$AppTemplateReasonReact.getDomain(url)), React.createElement("span", undefined, ")"))), React.createElement("div", {
                  className: "story-item-footer"
                }, React.createElement("span", undefined, String(points) + " points"), React.createElement("span", undefined, author), React.createElement("span", undefined, Date$AppTemplateReasonReact.fromNow(createdAt)), comments));
}

var make = StoryItem;

export {
  make ,
  
}
/*  Not a pure module */
